import { Injectable } from '@angular/core';
import {ApiService, GetRequestArguments, Refresh} from './api.service';
import { BehaviorSubject } from 'rxjs';
import {HttpClient} from "@angular/common/http";
import {API_URL} from "../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class CurrencyService {

  public $allCurrencies = new BehaviorSubject([]);
  public $currencies = new BehaviorSubject([]);
  public $default = new BehaviorSubject(undefined);

  private url = 'currencies';
  private groupKey = 'currency';
  private ttl = 60 * 60 * 24 * 7;
  constructor(private api: ApiService,
              private http: HttpClient) {
    // this.load();
    // this.loadDefault();
  }

  public load(refresh: Refresh = 'expired') {
    const args = new GetRequestArguments({
      url: this.url,
      cacheGroup: this.groupKey,
      refresh,
      ttl: this.ttl,
      delayed: false
    });
    const call = this.api.cachedGetRequest(args);
    call.subscribe(currencies => {
      this.api.updateObservable(currencies, this.$currencies);
      const tenant = currencies.find(c => c.is_tenant_currency);
      this.$default.next(tenant || null)
    },
      error => { console.log(error); });
    return call;
  }

  public loadAll(refresh: Refresh = 'expired') {

    const args = new GetRequestArguments({
      url: this.url,
      cacheGroup: this.groupKey,
      refresh,
      ttl: this.ttl,
      delayed: false,
      getAll: true,
    });
    const call = this.api.cachedGetRequest(args);

    call.subscribe(currencies => {
      this.api.updateObservable(currencies, this.$allCurrencies);
    },
      error => { console.log(error); }
    );
    return call;
  }
}
